import { type Role } from './user'

export interface Survey {
  applications: Array<{ id: number; name: string }>
  assignedUsers: Array<{
    userId: number
    username: string
    role: Role
  }>
  createdAt: string
  id: number
  indicatorsCount: number
  locked: boolean
  lockedBy: string
  lockedByUserId: number | null
  organizations: Array<{ id: number; name: string }>
  // NOTE: I think I'm missing more items here
  status: SurveyStatus
  anonymousSurvey?: boolean
  title: string
  updatedAt: string
}

export interface LifemapQuestion {
  codeName: string
  // TODO: type this
  definition: any | null
  description: string
  dimension: string
  id: number
  orderNumber: number
  // TODO: type this
  questionAudio: any | null
  questionText: string
  required: boolean
  reviewed: boolean
  shortName: string
  status: SurveyStatus
  stoplightColors: LifemapLevel[]
  surveyIndicator: { codeName: string }
  surveyStoplightDimension: { id: number }
}

export interface LifemapLevel {
  description: string
  url: string
  urlImage: string
  value: 1 | 2 | 3 | 9 | 0
}

export type SurveyStatus = 'IN_REVIEW' | 'APPROVED' | 'REVIEWED'
/**
 * @deprecated Use StoplightColor instead as an enum
 */
export type IndicatorValue = 1 | 2 | 3 | 9 | 0

/**
 * @deprecated Use StoplightColor from packages/shared/types instead
 */
export enum StoplightColorValue {
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  DOES_NOT_APPLY = 9,
  SKIPPED = 0,
}

export interface SurveyLifemapQuestion {
  questionType: LifemapQuestionType
  questionText: string
}

export type LifemapQuestionType =
  | 'STATUS'
  | 'INDICATOR'
  | 'PRIORITY_REASON'
  | 'PRIORITY_ACTION'
  | 'ACHIEVEMENT_ACTION'
  | 'ACHIEVEMENT_ROADMAP'
  | 'PRIORITY_REVISION_DATE'
  | 'PRIORITY_ESTIMATED_DATE'
